var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newsitem-vertical-container",on:{"click":_vm.toViewDetail}},[_c('ImageCard',{staticClass:"img-card",attrs:{"src":_vm.newsInfo.cover}}),_c('div',{staticClass:"newsitem-content"},[_vm._v(_vm._s(_vm.newsInfo.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }